<template>
    <div class="index">
        <div class="outside-wrapper">
            <div class="container-fluid">
                <transition name="fade">
                    <form v-if="!loading" id="f-event-filters" method="get">
                        <div class="row section-filters">
                            <div class="col-12">
                                <h2>Nadchodzące wydarzenia</h2>
                            </div>

                            <div class="col-md-4">
                                <button class="btn btn-link btn-link-ms collapsed" type="button" v-b-toggle.filter-date>
                                    Data
                                    <img v-bind:src="getAssetPath('img/icon-arrowhead-down.png')" alt="">
                                </button>
        
                                <div class="collapse show filter-active-item filter-date-collapse" id="filter-date-active">
                                        <span v-if="!selectedDates.length && years.length">
                                            {{ years.length === 1 ? years[0] : `${years[0]} - ${years[years.length - 1]}` }}
                                        </span>
                                        <span v-for="date in selectedDates" v-html="date" :key="date"></span>
                                    </div>
        
                                    <b-collapse class="filter-items filter-date-collapse" id="filter-date">
                                        <div class="form-group">
                                            <div class="custom-control custom-checkbox" v-for="year in years" :key="year">
                                                <input type="checkbox" class="custom-control-input" v-bind:id="'year-'+year" v-bind:value="year" v-model="selectedDates">
                                                <label class="custom-control-label" v-bind:for="'year-'+year" v-html="year"></label>
                                            </div>
                                        </div>
                                </b-collapse>
                            </div>
        
                            <div class="col-md-4">
                                <button class="btn btn-link btn-link-ms collapsed" type="button" v-b-toggle.filter-specialty>
                                    Specjalizacja
                                    <img v-bind:src="getAssetPath('img/icon-arrowhead-down.png')" alt="">
                                </button>
        
                                <div class="collapse show filter-active-item filter-specialty-collapse" id="filter-specialty-active">
                                    <span v-if="!selectedSpecializations.length"> Wszystkie </span>
                                    <span v-for="spec in selectedSpecializations" v-html="spec" :key="spec"></span>
                                </div>
        
                                <b-collapse class="collapse filter-items filter-specialty-collapse" id="filter-specialty">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox" v-for="specialization in specializations" :key="specialization">
                                            <input type="checkbox" class="custom-control-input" v-bind:id="'specialization-'+specialization"
                                                v-bind:value="specialization" v-model="selectedSpecializations">
                                            <label class="custom-control-label" v-bind:for="'specialization-'+specialization" v-html="specialization"></label>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
        
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" v-model="searchQuery" @input="debouncedFilter" @keydown.enter.prevent placeholder="Wpisz nazwę wydarzenia" aria-label="Wpisz nazwę wydarzenia" aria-describedby="button-search">
                                </div>
                            </div>
                        </div>
                    </form>
                </transition>
                <div class="outside-wrapper">
                    <div class="container-fluid">
                        <div v-if="loading" class="loader"></div>
                        <transition-group name="fade" tag="div" class="row section-events-list" v-else>
                            <single-event v-for="(event, index) in events.slice(0, 6)" :event="event" :key="event.name" :asset_path="asset_path"></single-event>
                        </transition-group>
                        <div v-if="events.length === 0" class="no-events">
                            Brak wydarzeń do wyświetlenia.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="featuredEvents.length > 0" class="outside-wrapper outside-wrapper-purple">
            <div class="container-fluid">
                <div class="row section-events-list">
                    <div class="col-12">
                        <h2>Wyróżnione wydarzenia</h2>
                    </div>
                    <single-event v-for="event in featuredEvents.slice(0, 6)" :event="event" :key="event.name+' '" :asset_path="asset_path"></single-event>
                </div>
            </div>
        </div>

        <div class="outside-wrapper">
        <div class="container-fluid">
            <div class="row section-events-list">
                <single-event v-for="event in events.slice(6, 12)" :event="event" :key="event.name" :asset_path="asset_path"></single-event>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import FormInput from "../../../fit2/js/components/formInput";
import Spinner from 'vue-simple-spinner';
import debounce from 'lodash/debounce';

export default {
    components: {
        FormInput,
        Spinner,
    },
    props: ['asset_path'],
    created() {
        this.fetchData();
        this.filter();
        this.debouncedFilter = debounce(this.filter, 300);
    },
    data() {
        return {
            selectedDates: [],
            selectedSpecializations: [],
            events: [],
            featuredEvents: [],
            specializations: [],
            years: [],
            searchQuery: '',
            loading: true
        }
    },
    watch: {
        selectedSpecializations: 'filter',
        selectedDates: 'filter'
    },
    methods: {
        fetchData() {
            axios.get('/api/fetch')
            .then((response) => {
                this.specializations = response.data.specializations;
                this.years = response.data.years;
                this.selectedDates = response.data.years;
                this.filter();
                this.loading = false;
            });

            axios.get('/api/eventables/featured')
                .then(response => {
                    this.featuredEvents = response.data.data
                });
        },
        filter() {
            axios.get('/api/eventables', {
                params: {
                    specializations: this.selectedSpecializations,
                    years: this.selectedDates,
                    searchQuery: this.searchQuery
                }
            })
            .then(response => {
                this.events = response.data.data;
            })
        },
        getAssetPath(path) {
            return this.asset_path + '/' + path;
        }
    }

}

</script>
<style scoped>
.loader {
    text-align: center;
    padding: 50px;
    font-size: 20px;
    color: #333;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
}
.no-events {
    text-align: center;
    padding: 50px;
    font-size: 20px;
    color: #333;
}
</style>